import React from 'react'
import { makeStyles, createStyles } from '@mui/styles'

interface CustomHeaderProps {
    value: string
    color?: string
    id: string
}
const useStyles = makeStyles(() =>
    createStyles({
        root: {
            alignItems: 'center',
            lineHeight: '24px',
            width: '100%',
            height: '100%',
            position: 'relative',
            display: 'flex',
            padding: '20px 4px',
        },
    }),
)

export const CustomHeader = React.memo(function GridCellExpand(props: CustomHeaderProps) {
    const { value } = props
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-between',
                    alignItems: 'center',
                    position: 'relative',
                    width: '100%',
                    overflow: 'hidden',
                    paddingRight: '20px',
                }}
            >
                <div
                    style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        wordBreak: 'break-word',
                        overflow: 'hidden',
                    }}
                >
                    {value}
                </div>
            </div>
        </div>
    )
})
